module.exports = __webpack_public_path__ + "static/img/zhangxinyuan.a48c36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/zhangxinyuan.png
// module id = YcT7
// module chunks = 0